import { renderIcon } from '@opallabs/kuiper'
import { colors } from '@opallabs/spectrum'

interface AssignmentStarProps {
  starred: boolean
  onClick: React.MouseEventHandler<HTMLElement>
}

export const AssignmentStar: React.FC<AssignmentStarProps> = ({
  starred,
  onClick,
}) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
  <div
    className="task-star"
    data-testid="task-star"
    css={{
      color: starred ? colors.n4.base : colors.n8.base,
      cursor: 'pointer',
      display: 'flex',
      opacity: 0,
      padding: '2px 0px',
      position: 'relative',
      '.kuiper-icon-wrapper': {
        transition: starred ? '' : 'width 0.15s ease',
      },
      '&:hover': {
        color: colors.n5.base,
      },
    }}
    onClick={onClick}
  >
    {renderIcon('channel-star-sm', {
      height: 14,
      width: 14,
      ariaLabel: starred ? 'Unstar this task' : 'Star this task',
      ariaMode: 'presentational',
    })}
  </div>
)
